/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type jiraTempoOauthTokenSection_company = {
    readonly tempoOauthTokenApplied: boolean | null;
    readonly jiraBaseUrl: string | null;
    readonly tempoOauthClientId: string | null;
    readonly tempoOauthClientSecret: string | null;
    readonly " $refType": "jiraTempoOauthTokenSection_company";
};
export type jiraTempoOauthTokenSection_company$data = jiraTempoOauthTokenSection_company;
export type jiraTempoOauthTokenSection_company$key = {
    readonly " $data"?: jiraTempoOauthTokenSection_company$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"jiraTempoOauthTokenSection_company">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "jiraTempoOauthTokenSection_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tempoOauthTokenApplied",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "jiraBaseUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tempoOauthClientId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tempoOauthClientSecret",
      "storageKey": null
    }
  ],
  "type": "Company"
};
(node as any).hash = '9cf00816a64bfb2cce5c70ea646db180';
export default node;
